var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingSingle = function SvgBuildingSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.37 3a1 1 0 0 0-1-1H6.5a1 1 0 0 0-1 1v10.83h4.87V3Z",
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 6.89,
    y: 3.74,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 6.89,
    y: 6.87,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 6.89,
    y: 9.65,
    fill: "currentColor",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.5 14.02h7",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBuildingSingle;